import React from 'react'
import styles from './documents.scss'
import * as c from 'state/constants'
import i18n from 'lib/i18n'
import nesProp from 'nested-property'

// variables out of module
const _ = i18n('dsdocuments')

/**
 * Popup content for status explainer
 * @param {*} doc
 */
export const statusExplainerPopup = (title, content, callBack, ok) => {
    return (
        <div className={styles.documentsModalContent}>
            <span className={styles.title}>{title}</span>
            <span className={styles.message}>
                <div className={styles.dsDocumentDescriptionContainer}>
                    {/* <span className={styles.contentTitle}>{title}</span> */}
                    <div className={styles.content}>{content}</div>
                </div>
            </span>
            <div className={styles.documentsModalButtons}>
                <input
                    onClick={() => {
                        callBack()
                    }}
                    type="button"
                    className={styles.greenButton + " enabled"}
                    value={ok + ""}
                />
            </div>
        </div>
    )
}

/**
 * General customization for modals in DSDocuments module
 * Mostly is the same like in other modules but sometimes is customized
 */
export const customModalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        whiteSpace: 'pre-wrap',
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
        width: '70%',
        height: 'auto'
    }
}

/**
 * General customization for modals in DSDocuments module
 * Mostly is the same like in other modules but sometimes is customized
 */
export const customModalStylesForFillForm = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
        width: '90%',
        height: '90%'
    }
}

/**
* THis function helps to generate a translation key by status
*/
export const getStatusTranslationKey = (status) => {
    if (!status) {
        return 'status_none'
    }
    return 'status_' + status.charAt(0).toUpperCase() + status.slice(1)
}

/**
* THis function helps to generate a translation key for description of status
*/
export const getStatusDescriptionTranslationKey = (status) => {
    if (!status) {
        return 'status_description_none'
    }

    return 'status_description_' + status.charAt(0).toUpperCase() + status.slice(1)
}

/**
* This function returns true if a status is a fail for dsdocuments
*/
export const isAFailStatus = (status) => {
    if (!status) {
        return false
    }

    return [
        c.DS_PACKAGE_STATUS_FAILED,
        c.DS_DOCUMENTS_ERROR,
        c.DS_PACKAGE_STATUS_REJECTED,
        c.DS_PACKAGE_STATUS_REVOKED,
        c.DS_PACKAGE_STATUS_EXPIRED,
        c.DS_PACKAGE_STATUS_FAILED,
    ].includes(status)
}

export const escapeSpecialChars = (inputString) => {
    return inputString.replace(/\\n/g, "\\n")
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, "\\&")
        .replace(/\\r/g, "\\r")
        .replace(/\\t/g, "\\t")
        .replace(/\\b/g, "\\b")
        .replace(/\\f/g, "\\f");
}

/**
* This function provide false if the package must be locked.
* @param {*} statusHistory
*/
export const shouldEditThePackage = (statusHistory, isEditable) => {
    let should = true

    // v6.5 implemented to detect if the package is editable or not, for the old records must be checked the status history
    // in case when the isEditable is null or undefined then that is an old record before v6.5, no to be considered as condition
    if (isEditable === false) {
        should = false
        return should
    }

    // v6.0 checking the status history
    if (!statusHistory) {
        return true
    }

    // v6.0 checking the status history
    statusHistory.forEach((oneStatus) => {
        if (oneStatus.status === c.DS_PACKAGE_STATUS_PENDING) {
            should = false
        }
    })

    return should
}

/**
 * Check if all stakeholders have signed
 * @param {*} dsPackage
 * @returns
 */
export const stakeholdersCanSign = (dsPackage) => {
    let canSign = false
    if (!dsPackage) {
        return
    }
    dsPackage.dsStakeholders.forEach(stakeholder => {
        if (stakeholder.roles && stakeholder.roles.length > 0) {

            stakeholder.roles.forEach(role => {
                if (role.type === 'signer' && role.status === 'Available') {
                    canSign = true
                }
            })
        }
    })
    return canSign
}

/**
 * Check if stakeholder has available action used for sending invitation to sign
 * @param {*} stakeholder 
 * @returns Boolean
 */
export const stakeholderMustAct = (stakeholder) => {

    let mustAct = false
    if (stakeholder.roles && stakeholder.roles.length > 0) {

        stakeholder.roles.forEach(role => {
            if ((role.type === 'signer' && role.status === 'Available') || (role.type === 'formFiller' && role.status === 'Available')) {
                mustAct = true
            }
        })
    }

    return mustAct
}

/**
 * Check if all stakeholders have signed
 * @param {*} dsPackage
 * @returns
 */
export const stakeholdersNeedInvitation = (dsPackage) => {
    let notInvited = false
    if (!dsPackage) {
        return
    }

    dsPackage.dsStakeholders.forEach(stakeholder => {
        if (!stakeholder.isInvited && stakeholder.signerType !== "BROKER") {
            notInvited = true
        }
    })

    return notInvited
}

/**
* This function checks if a document is signed.
* @param {*} document
* @returns
*/
export const isSignedTheDocument = (document) => {
    let isSigned = false

    if (document && document.package && document.package.statusHistory) {
        document.package.statusHistory.forEach((oneStatus, index) => {
            if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
                isSigned = true
            }
        })
    }

    return isSigned
}

/**
 * This function return true when there is a linking action required for an entity.
 * @param {*} dsDocument
 * @returns Boolean - true is must be linked to an entity and not linked yet, false if not required linking
 * or already linked.
 */
export const shouldToLinkWithContract = (dsDocument) => {
    // if uploaded or there are wrong paramteres the return false
    if (!dsDocument || dsDocument.uploadedToOracle) {
        return false
    }

    // collecting the logical values for determination of result
    let isRequiredContractId =
        (nesProp.get(dsDocument, "documentTemplate.uploadedOnModule") === c.DS_MODULE_CLIENT_CONTRACT)

    // the template is not contract based
    if (!isRequiredContractId) {
        return false
    }

    let hasContractId = nesProp.get(dsDocument, "contractId")

    // determine the result
    return (isRequiredContractId && !hasContractId)
}

/**
 * This function return true when there is a linking action required for a claim.
 * @param {*} dsDocument
 * @returns Boolean - true is must be linked to a claim and not linked yet, false if not required linking
 * or already linked.
 */
export const shouldToLinkWithClaim = (dsDocument) => {
    // if uploaded or there are wrong paramteres the return false
    if (!dsDocument || dsDocument.uploadedToOracle) {
        return false
    }

    // collecting the logical values for determination of result
    let isRequiredClaimId =
        (nesProp.get(dsDocument, "documentTemplate.uploadedOnModule") === c.DS_MODULE_CLIENT_CLAIMS)

    // the template is not claim based
    if (!isRequiredClaimId) {
        return false
    }

    let hasClaimId = nesProp.get(dsDocument, "claimId")

    // determine the result
    return (isRequiredClaimId && !hasClaimId)
}

/**
 * This function return true when there is a linking action required for a tarification.
 * @param {*} dsDocument
 * @returns Boolean - true is must be linked to a tarification and not linked yet, false if not required linking
 * or already linked.
 */
export const shouldToLinkWithTarification = (dsDocument) => {
    // if uploaded or there are wrong paramteres the return false
    if (!dsDocument || dsDocument.uploadedToOracle) {
        return false
    }

    // collecting the logical values for determination of result
    let isRequiredTarificationId =
        (nesProp.get(dsDocument, "documentTemplate.uploadedOnModule") === c.DS_MODULE_CLIENT_TARIFICATION)

    // the template is not tarification based
    if (!isRequiredTarificationId) {
        return false
    }

    let hasTarificationId = nesProp.get(dsDocument, "tarificationId")

    // determine the result
    return (isRequiredTarificationId && !hasTarificationId)
}




// WEBPACK FOOTER //
// ./components/DSDocuments/documentsHelpers.jsx